import { render, staticRenderFns } from "./NotificacoesView.vue?vue&type=template&id=ebcbd0dc"
import script from "./NotificacoesView.vue?vue&type=script&lang=js"
export * from "./NotificacoesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports